export type Joint = { x: number; y: number };
export function twoBone(root: Joint, target: Joint, upper: number, lower: number, bend = 1): { elbow: Joint; end: Joint } {
  const dx = target.x - root.x, dy = target.y - root.y;
  const distance = Math.max(.001, Math.hypot(dx, dy));
  const reach = Math.max(Math.abs(upper - lower) + .001, Math.min(upper + lower - .001, distance));
  const base = Math.atan2(dy, dx);
  const angle = Math.acos(Math.max(-1, Math.min(1, (upper * upper + reach * reach - lower * lower) / (2 * upper * reach))));
  return { elbow: { x: root.x + Math.cos(base + bend * angle) * upper, y: root.y + Math.sin(base + bend * angle) * upper }, end: { x: root.x + dx / distance * reach, y: root.y + dy / distance * reach } };
}
export function smooth(current: number, target: number, response: number, seconds: number): number {
  return current + (target - current) * (1 - Math.exp(-response * seconds));
}
